module.exports = __webpack_public_path__ + "img/desktop1.13db20e8.png";